import { useTranslation } from "react-i18next";
import { Card, Typography } from "@material-ui/core";

import { EmailFlowLog } from "@dashboard-v3/api";
import { useStyles } from "../styles";

interface Props {
  email: EmailFlowLog;
}

export default function EmailStatusOverview(props: Props) {
  const { t } = useTranslation("emailFlowLogs");
  const classes = useStyles();
  const { email } = props;

  return (
    <div style={{ display: "flex", flexDirection: "column" }}>
      <Typography variant="subtitle2">{t("deliveryStatus.title")}</Typography>
      <div className={classes.cardsContainer}>
        <Card className={classes.card}>
          <Typography
            className={classes.cardText}
            variant="caption"
            color="primary"
          >
            {t("deliveryStatus.totalDelivered.label")}
          </Typography>
          <Typography variant="subtitle2">{email.totalDelivered}</Typography>
        </Card>
        <Card className={classes.card}>
          <Typography
            className={classes.cardText}
            variant="caption"
            color="primary"
          >
            {t("deliveryStatus.totalQueued.label")}
          </Typography>
          <Typography variant="subtitle2">{email.totalQueued}</Typography>
        </Card>
        <Card className={classes.card}>
          <Typography
            className={classes.cardText}
            variant="caption"
            color="primary"
          >
            {t("deliveryStatus.totalRejected.label")}
          </Typography>
          <Typography variant="subtitle2">{email.totalRejected}</Typography>
        </Card>
        <Card className={classes.card}>
          <Typography
            className={classes.cardText}
            variant="caption"
            color="primary"
          >
            {t("deliveryStatus.totalDropped.label")}
          </Typography>
          <Typography variant="subtitle2">{email.totalDropped}</Typography>
        </Card>
        <Card className={classes.card}>
          <Typography
            className={classes.cardText}
            variant="caption"
            color="primary"
          >
            {t("deliveryStatus.totalError.label")}
          </Typography>
          <Typography variant="subtitle2">{email.totalError}</Typography>
        </Card>
        <Card className={classes.card}>
          <Typography
            className={classes.cardText}
            variant="caption"
            color="primary"
          >
            {t("deliveryStatus.totalQuarantine.label")}
          </Typography>
          <Typography variant="subtitle2">{email.totalQuarantine}</Typography>
        </Card>
      </div>
    </div>
  );
}
